import { render, staticRenderFns } from "./NewDFileUploadPreview.vue?vue&type=template&id=11021af1&"
import script from "./NewDFileUploadPreview.vue?vue&type=script&lang=js&"
export * from "./NewDFileUploadPreview.vue?vue&type=script&lang=js&"
import style0 from "./NewDFileUploadPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports